/**
 * Client-side PR URL validation for instant feedback. The server re-validates every request
 * (see server/src/utils/githubUrl.ts) — this is a convenience, not a security boundary.
 */
export function validatePrUrl(input: string): string | null {
  const raw = input.trim();
  if (!raw) return 'Enter a GitHub Pull Request URL.';
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return 'This is not a valid URL. Expected https://github.com/{owner}/{repo}/pull/{number}.';
  }
  if (url.protocol !== 'https:') return 'Only https:// GitHub URLs are supported.';
  if (!['github.com', 'www.github.com'].includes(url.hostname.toLowerCase())) {
    return 'Only github.com Pull Request URLs are supported.';
  }
  const seg = url.pathname.split('/').filter(Boolean);
  if (seg.length < 4 || seg[2] !== 'pull') return 'Expected a Pull Request URL like https://github.com/owner/repo/pull/123.';
  if (!/^[1-9][0-9]{0,8}$/.test(seg[3] ?? '')) return 'The Pull Request number is not valid.';
  return null;
}
